import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Avatar,
  Typography,
  Button,
  Slide,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Warning } from "@mui/icons-material";

export function ConfirmDeleteDialog({ deleteDialog, setDeleteDialog, theme }) {
  return (
    <Dialog
      open={deleteDialog.open}
      onClose={() => setDeleteDialog(prev => ({ ...prev, open: false }))}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up' }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.error.main, 0.1), width: 40, height: 40 }}>
            <Warning sx={{ color: 'error.main' }} />
          </Avatar>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {deleteDialog.title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {deleteDialog.message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={() => setDeleteDialog(prev => ({ ...prev, open: false }))}
          sx={{ color: 'text.secondary', borderColor: 'divider' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={async () => {
            setDeleteDialog(prev => ({ ...prev, open: false }));
            if (deleteDialog.onConfirm) await deleteDialog.onConfirm();
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteDialog;
